import { PrivatePendingProfileMask, PublicPendingProfileMask } from '@sda/sdk/masks';
import { Reducers } from '@sda/enums/store';
import { SDKFactory } from './helpers/sdk.factory';
import { SDK } from './helpers/sdk';
import type { FetchDataType, FirestoreClientData } from './interfaces';
import type { PublicPendingProfile, PrivatePendingProfile, PendingProfile } from '@sda/interfaces/profile';

/**
 * SDK Class to interact with Firestore Profiles.
 */
export class Profiles extends SDK<PublicPendingProfile> {
  constructor(apiClient: FirestoreClientData) {
    super(apiClient, Reducers.PROFILES);

    this.collection = this.fsh.Schema.PublicProfiles;

    this.PublicMap = PublicPendingProfileMask;

    this.PrivateMap = PrivatePendingProfileMask;
  }

  async getCombined(id: string): Promise<PendingProfile & FetchDataType> {
    return this.getCombinedRecord<PrivatePendingProfile>(
      id,
      this.Private().collection,
    );
  }

  Private(): SDK<PrivatePendingProfile> {
    return SDKFactory<PrivatePendingProfile>(this.fsh.clientData, this.fsh.Schema.PrivateProfiles, { reducerName: Reducers.PROFILES });
  }
}
